import gql from "graphql-tag";

export const WORKOUT_BLOCKS_QUERY = gql`
  query workoutBlocks($orderBy: String) {
    workoutBlocks(orderBy: $orderBy) {
      edges {
        node {
          id
          blockId
          title
          type
          visible
          productVariant {
            id
          }
        }
      }
    }
  }
`;

export const SUBSCRIPTION_BLOCK_QUERY = gql`
  query subscriptionBlock($subscriptionBlockId: ID!) {
    subscriptionBlock(id: $subscriptionBlockId) {
      id
      startDate
      originalStartDate
      isSelfPaced
      block {
        id
        title
      }
    }
  }
`;

export const COACHING_BLOCK_MUTATION = gql`
  mutation coachingSubscriptionBlockMutation($input: UserSubscriptionBlockInput!) {
    coachingSubscriptionBlockMutation(data: $input) {
      error
      success
    }
  }
`;

export const RECOMMENDED_WORKOUT_JOURNEY_QUERY = gql`
  query recommendedWorkoutJourney($userId: ID!) {
    recommendedWorkoutJourney(userId: $userId) {
      id
      title
      image
      price
      type
      duration
      strikePrice
      hasCompleted
      leadInstructor {
        id
        firstName
        lastName
        userProfile {
          id
          profilePicture
        }
      }
      secondaryInstructor {
        id
        firstName
        lastName
        userProfile {
          id
          profilePicture
        }
      }
    }
  }
`;

export const WORKOUT_BLOCKS_NODE_QUERY = gql`
  query workoutBlocks(
    $type: String
    $typeIn: [String]
    $leadInstructor: ID
    $leadInstructorsIn: [ID]
    $instructorsIn: [String]
    $fitnessLevelTagsIn: [String]
    $specialityTagsIn: [String]
    $search: String
    $tags: String
    $startDateLte: Date
    $startDateGte: Date
    $first: Int
    $after: String
    $orderBy: String
    $withUsers: Boolean!
    $showAccountabilityGroupRegistration: Boolean
  ) {
    workoutBlocks(
      type: $type
      type_In: $typeIn
      leadInstructor: $leadInstructor
      leadInstructor_In: $leadInstructorsIn
      instructorsIn: $instructorsIn
      tags: $tags
      fitnessLevelTagsIn: $fitnessLevelTagsIn
      specialityTagsIn: $specialityTagsIn
      search: $search
      startDate_Lte: $startDateLte
      startDate_Gte: $startDateGte
      showAccountabilityGroupRegistration: $showAccountabilityGroupRegistration
      first: $first
      after: $after
      orderBy: $orderBy
    ) {
      pageInfo {
        endCursor
        hasNextPage
      }
      edges {
        node {
          id
          blockId
          title
          image
          price
          type
          startDate
          facebookUrl
          whatsappUrl
          hasCompleted
          activeUsers
          completedUsers
          productVariant {
            id
          }
          userList @include(if: $withUsers) {
            id
            firstName
            lastName
            profilePicture
          }
          leadInstructor {
            id
            firstName
            lastName
            userProfile {
              id
              profilePicture
            }
          }
          secondaryInstructor {
            id
            firstName
            lastName
            userProfile {
              id
              profilePicture
            }
          }
        }
      }
    }
  }
`;

export const BLOCK_REPORT = gql`
  query blockReport($workoutBlockId: ID!) {
    blockReport(workoutBlockId: $workoutBlockId) {
      day
      exerciseDots
      nutritionDots
      mindsetDots
      daySessionDots
    }
  }
`;
